module.exports = __webpack_public_path__ + "img/login.ad864a76.png";